(function() {
    const stopVideo = section => {
        const videos = section.querySelectorAll("video");
        videos && videos.forEach(video => {
            video.pause()
        }
        )
    }
      , playVideo = (section, width) => {
        const videos = section.querySelectorAll("video")
          , cards = section.querySelectorAll(".gallery-with-text__card");
        videos && cards && cards.forEach(card => {
            card.querySelector("video") && (card.classList.contains("active") || width < 990 ? card.querySelector("video").play() : card.querySelector("video").pause())
        }
        )
    }
      , galleryTextSlide = () => {
        $(".gallery-with-text__card").hover(function() {
            let $this = $(this);
          const attr = $this.attr("data-attr");
           // Match data-attr with bottom section
        $(".gallery-with-text__info-item-below").removeClass("active");
  //      $(`.gallery-with-text__info-item-below[data-attr='${attr}']`).addClass("active");
            $this.addClass("active"),
            $this.siblings(".gallery-with-text__card").removeClass("active"),
            setTimeout(function() {
                $this.children(".gallery-with-text__info").children(".link--overlay").addClass("active"),
                $this.siblings(".gallery-with-text__card").children(".gallery-with-text__info").children(".link--overlay").removeClass("active")
            }, 100),
            playVideo($this.closest(".gallery-with-text-section")[0], document.documentElement.clientWidth)
        })
    }
      , initSection = () => {
        const sections = document.querySelectorAll(".gallery-with-text-section")
          , sectionObserver = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                entry.isIntersecting ? playVideo(entry.target, entry.boundingClientRect.width) : stopVideo(entry.target)
            }
            )
        }
        )
          , sectionResizeObserver = new ResizeObserver(entries => {
            const [entry] = entries;
            let widthSlide = "100%";
            document.documentElement.clientWidth >= 990 ? (entry.target.querySelectorAll(".gallery-with-text__card").forEach(card => {
                card.classList.contains("active") && (widthSlide = card.getBoundingClientRect().width)
            }
            ),
            entry.target.style.setProperty("--width-slide", `${widthSlide}px`)) : entry.target.style.setProperty("--width-slide", "100%"),
            playVideo(entry.target, entry.contentRect.width)
        }
        );
        sections.forEach(section => {
            sectionObserver.observe(section),
            sectionResizeObserver.observe(section)
        }
        ),
        galleryTextSlide()
    }
    ;
    document.addEventListener("shopify:section:load", function() {
        initSection()
    }),
    initSection()
}
)(); 
